import { TenantEnum } from './enums/tenant.enum';

export const createLeaderboardKey = (
  league_id: number | string,
  tournament_id: number | string,
  tenant?: TenantEnum,
): string => `${league_id}/${tournament_id}[${tenant || null}]`;
